import Refinements from './Refinements.vue'

export default Refinements
